import _uniqueId from "lodash/uniqueId";


export var attachId = function (func) {
  return function () {
    return {
      mutations: func.apply(undefined, arguments),
      id: _uniqueId("throttledEvent")
    };
  };
};